import axios from "axios";
import { EconomyByType } from "./simulatorTypes";

export const fetchSimulatorData = async ({
  token,
  solutionType = "COMBINED",
  voltageLevel = "MEDIUM",
  ...others
}:
  | { token: string; solutionType?: string; voltageLevel?: string } & (
      | { propertyId: string }
      | { monthlyEnergyCost: string }
    )) => {
  let suffix = `?solutionType=${solutionType}&voltageLevel=${voltageLevel}`;
  Object.keys(others).forEach((key) => {
    suffix += `&${key}=${others[key]}`;
  });
  return axios
    .get<Promise<EconomyByType>>(
      `${process.env.REACT_APP_API_PATH}/users/contract_energy/simulator${suffix}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
